import React from "react";
import { useGetAnalyticsConfigurationQuery } from "../generated/graphql";
import { GTM } from "../vendors/gtm";
import { BranchIO } from "../vendors/branchio";
import { Snowplow } from "../vendors/snowplow/Snowplow";

type AnalyticsVendorsProps = {
  host: string;
};

export const AnalyticsVendors = ({ host }: AnalyticsVendorsProps) => {
  const { data } = useGetAnalyticsConfigurationQuery({
    variables: { domain: host },
  });

  const analytics = data?.cmsConfiguration.analytics;

  if (!analytics) {
    return null;
  }

  const snowplowConfig = analytics.snowplow;

  return (
    <>
      <GTM {...analytics?.gtm} />
      <BranchIO {...analytics?.branchio} />
      <Snowplow config={snowplowConfig} />
    </>
  );
};
